import styled from '@emotion/styled';
import { useRouter } from 'next/router';

// components
import CompanyInfoEditForm from './EditForm/CompanyInfoEditForm';
import PasswordEditForm from './EditForm/PasswordEditForm';
import NameEditForm from './EditForm/NameEditForm';
import PhoneEditForm from './EditForm/PhoneEditForm';
import CompanyDepartmentEditForm from './EditForm/CompanyDepartmentEditForm';
import CompanyTitleEditForm from './EditForm/CompanyTitleEditForm';
import MaterialAlarmEditForm from './EditForm/MaterialAlarmEditForm.tsx';
import { MOBILE_MODE } from '@constants/size';
import CompanyNameEditForm from './EditForm/CompanyNameEditForm';

const Layout = styled.div``;
const EditUserInfoForm = styled.div`
  max-width: 344px;
  margin: 0 auto;

  @media ${MOBILE_MODE} {
    max-width: 320px;
  }
`;
const EditMaterialAlarmForm = styled.div`
  max-width: 1080px;
  margin: 0 auto;

  @media ${MOBILE_MODE} {
    max-width: 360px;
  }
`;

export default function EditContent() {
  const router = useRouter();
  const { type } = router.query;

  return (
    <Layout>
      {/* EditForm */}
      <EditUserInfoForm>
        {type === 'password' && <PasswordEditForm />}
        {type === 'company_info' && <CompanyInfoEditForm />}
        {type === 'company_name' && <CompanyNameEditForm />}
        {type === 'name' && <NameEditForm />}
        {type === 'phone' && <PhoneEditForm />}
        {type === 'company_department' && <CompanyDepartmentEditForm />}
        {type === 'company_title' && <CompanyTitleEditForm />}
      </EditUserInfoForm>
      {type === 'material_alarm' && (
        <EditMaterialAlarmForm>
          <MaterialAlarmEditForm />
        </EditMaterialAlarmForm>
      )}
      {/* EditForm end */}
    </Layout>
  );
}
